module.exports = __webpack_public_path__ + "img/icon-no-list.3d7d640e.svg";